import { FC, HTMLProps } from 'react'
import { Button } from './styled'
import { IconArrow } from 'components/icons/arrow'

type Props = {
  isCurrent: boolean
  isNext?: boolean
  className?: string
} & HTMLProps<HTMLButtonElement>

export const NavButton: FC<Props> = ({
  isCurrent,
  onClick,
  isNext,
  className = '',
}) => (
  <Button
    className={className}
    $isCurrent={isCurrent}
    onClick={onClick}
    $isNext={isNext}
  >
    <IconArrow />
  </Button>
)
